module.exports = __webpack_public_path__ + "img/employees.8dfa0f75.png";